import { Branding, DisabledPrompt, Outlet, StateManager, useModel, useParams, useRoute, useStateManager } from '@bcm-dev/bcms-vite';
import { Card, Util } from "model";
import React, { useEffect, useState } from "react";

import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import TabsContainer, { TabItem } from "components/shared/containers/TabsContainer";
import PurchasesView from "./components/PurchasesView";

import "./styles.css";

/**
 * @function ViewAllTransactionsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ViewAllTransactionsPage
 */

export default function ViewAllTransactionsPage(props) {
  const model = useModel();
  const cardID = useParams().cardID ?? Util.getDefaultCardID(model);
  const data = { ...getDefaultData(cardID), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

return (
  <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
  </StateManager>
);
}

export const getDefaultData = cardID => {
  const _cardID = cardID ? cardID : "0";
  const card = Card.initByID(_cardID);
  return {
      card,
      useDefaultViewForCapture: false
  };
}

export const getDefaultUI = () => ({
  
});

function PageContent(props) {
  const { data, ui } = useStateManager();
  const workflowID = useParams().workflowID ?? "";
  const navigate = useRoute();

  const back = evt => {
    if(workflowID === "disputeTransactionWorkflow") {
      navigate(`/home/recenttransactions/${ data.card.id }`);
    } else {
      navigate(-1);
    }
  }

  // Pass this hook to the "Outlet" below
  // so that we can pass "data" and "ui" to the Outlet.
  const [ dataObj, setDataObj ] = useState({ data: data, ui });

  useEffect(() => {
    setDataObj({ data: data, ui });
  }, [ data, ui])

  const dataProp = data ? { data: data } : {};
  const uiProp = ui ? { ui: ui } : {};

  return (
    <MainContentContainer className="view-all-transactions-page" 
      header={ <MainContentHeader text="Transactions" onClick={ back } /> } >

      {/* This block of code is only used for capture components
      since "Outlet" is not used there. */}
      { data.useDefaultViewForCapture === true &&

      <div className="debit-card-content-container">
        <PurchasesView { ...dataProp } { ...uiProp } />
      </div> 
      }
      
      {/* START: Debit card view */}
      {/* This shows if a debit card is selected in the CardWidget */}
      { data.card.type === "debit" && data.useDefaultViewForCapture === false &&

        <div className="debit-card-content-container">
          <PurchasesView { ...dataProp } { ...uiProp } />
        </div> }
      {/* END: Debit card view */}

      {/* START: Credit card view */}
      {/* This shows if a credit card is selected in the CardWidget */}
      { data.card.type === "credit" && data.useDefaultViewForCapture === false &&
     
        <div className="credit-card-content-container">
          <Branding id="credit_select_chw23" exp={(val)=>{return val !== "true"}}>
          <TabsContainer>
            <TabItem text="Purchases" icon="ShopIcon" route={ `/home/viewalltransactions/purchases/${ data.card.id }` } activeRoute={[ "/home/viewalltransactions/purchases" ]} />

            <DisabledPrompt>
              <TabItem text="Fees & Payments" route={ `/home/viewalltransactions/feesandpayments/${ data.card.id }` } icon="TicketIcon" activeRoute={[ "/home/viewalltransactions/feesandpayments" ]} />
            </DisabledPrompt>
          </TabsContainer>
          </Branding>
          
          <Outlet context={ [ dataObj, setDataObj ] } />
        </div> 
      
        }
      {/* END: Credit card view */}

    </MainContentContainer>
  );
}